import {
  queryCompanyFengyunFiles,
  postCompanyFengyunFile,
} from '@/services/company';

export default {
  namespace: 'Devices_fengyunFiles',

  state: {
    data: {},
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const { status, data } = yield call(queryCompanyFengyunFiles, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data,
            pagination: {
              total: data.meta.total,
              pageSize: data.meta.per_page,
              current: data.meta.current_page,
            },
          },
        });
      }
    },

    *postFile({ payload, callback }, { call }) {
      yield call(postCompanyFengyunFile, payload);
      callback();
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
};
